import axios from 'axios';
import { API_URL } from '../config/apiConfig';


export const getClasses = async (affiliateId, date) => {

    const token = localStorage.getItem("token");
    try {
        if (!date || isNaN(new Date(date).getTime())) {
            console.error("❌ Invalid date received, using default today.");
            date = new Date();
        } else {
            date = new Date(date);
        }

        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(endOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        const response = await axios.get(`${API_URL}/classes`, {
            params: {
                affiliateId,
                start: startOfWeek.toISOString(),
                end: endOfWeek.toISOString()
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching classes:", error);
        return [];
    }
};

export const getClassesForSubdomain = async (affiliateId, date) => {


    try {
        if (!date || isNaN(new Date(date).getTime())) {
            console.error("❌ Invalid date received, using default today.");
            date = new Date();
        } else {
            date = new Date(date);
        }

        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(endOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        const response = await axios.get(`${API_URL}/classes/subdomain`, {
            params: {
                affiliateId,
                start: startOfWeek.toISOString(),
                end: endOfWeek.toISOString()
            },
            headers: {

                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching classes:", error);
        return [];
    }
};

export const createTraining = async (affiliateId, trainingData) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes`, {
            affiliateId, // ✅ Lisa affiliateId
            trainingType: trainingData.trainingType || "", // ✅ Tagame, et väärtused ei ole undefined
            trainingName: trainingData.trainingName || "", // ✅ Tagame, et väärtused ei ole undefined
            duration: trainingData.duration || "",
            trainer: trainingData.trainer || "",
            temporaryTrainerId: trainingData.temporaryTrainerId || null,
            memberCapacity: trainingData.memberCapacity || "",
            location: trainingData.location || "",
            repeatWeekly: trainingData.repeatWeekly || false,
            description: trainingData.description || "",
            descriptionIntermediate: trainingData.descriptionIntermediate || "",
            descriptionBeginner: trainingData.descriptionBeginner || "",
            descriptionStretching: trainingData.descriptionStretching || "",
            descriptionAtHome: trainingData.descriptionAtHome || "",
            videoLinks: Array.isArray(trainingData.videoLinks) ? trainingData.videoLinks : [],
            time: trainingData.time || "",
            wodName: trainingData.wodName || "",
            wodType: trainingData.wodType || "",
            freeClass: trainingData.freeClass || false,
            canRegister: trainingData.canRegister !== undefined ? trainingData.canRegister : true,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error creating training:", error);
    }
};

export const updateTraining = async (classId, trainingData) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.put(`${API_URL}/classes/${classId}`, trainingData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error updating training:", error);
    }
};

export const getClassWorkoutImage = async (classId) => {
    try {
        const response = await axios.get(`${API_URL}/classes/${classId}/workout-image`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) return null;
        console.error("Error fetching class workout image:", error);
        return null;
    }
};

export const uploadClassWorkoutImage = async (classId, imageFile) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("image", imageFile);

    const response = await axios.post(`${API_URL}/classes/${classId}/workout-image`, formData, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });

    return response.data;
};

export const deleteClassWorkoutImage = async (classId) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(`${API_URL}/classes/${classId}/workout-image`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
    return response.data;
};

export const deleteClass = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/classes/${classId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error deleting class:", error);
    }
};

export const getClassAttendeesCount = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/attendees/${classId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });

        const data = response.data;
        return data.count || 0; // ✅ Tagastame registreeritud osalejate arvu või 0
    } catch (error) {
        console.error("❌ Error fetching class attendees:", error);
        return 0; // ✅ Kui tekib viga, tagastame 0
    }
};

export const getClassAttendees = async (classId) => {
    try {
        const token = localStorage.getItem("token");
        const headers = {
            "Content-Type": "application/json",
        };
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios.get(`${API_URL}/class-attendees`, {
            params: {
                classId
            },
            headers
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching class attendees:", error);
    }
};

export const checkInAttendee = async (classId, userId, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.patch(`${API_URL}/class-attendees/check-in`,
            { classId, userId, familyMemberId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error checking in attendee:", error);
    }
};

export const deleteAttendee = async (classId, freeClass, userId, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/class-attendees`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            data: { classId, freeClass, userId, familyMemberId }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error deleting attendee:", error);
    }
};

export const registerForClass = async (classId, planId, affiliateId, freeClass, isFamilyMember, familyMemberId, additionalInfo) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes/register`,
            {
                classId,
                planId,
                affiliateId,
                freeClass,
                isFamilyMember,
                familyMemberId,
                additionalInfo,
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error registering for class:", error);
        throw error;
    }
};

export const cancelRegistration = async (classId, freeClass, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes/cancel`,
            {
                classId,
                freeClass, familyMemberId
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error cancelling registration:", error);
        throw error;
    }
};

export const getClassCancellationHistory = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/classes/cancellation-history`, {
            params: {classId},
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching class cancellation history:", error);
        throw error;
    }
};

export const getUserPlans = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/plans`, {
            params: { affiliateId },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });

        return response.data; // eeldame, et API tagastab massiivi kasutaja plaanidest
    } catch (error) {
        console.error("Error fetching user plans:", error);
        return [];
    }
};

export const checkUserEnrollment = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/class/check-enrollment`, {
            params: { classId },
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error checking enrollment:", error);
    }
};

export const getUserClassScore = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/classes/leaderboard/check`, {
            params: { classId },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        return response.data;
        // eeldame, et server tagastab: { hasScore: true/false, scoreType?: "...", score?: "..." }
    } catch (error) {
        console.error("Error checking user class score:", error);
        throw error;
    }
};

export const addClassScore = async (classData, scoreType, score, comment) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes/leaderboard/add`,
            { classData, scoreType, score, comment },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error adding class score:", error);
        throw error;
    }
};

export const updateClassScore = async (classData, scoreType, score, comment) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.put(`${API_URL}/classes/leaderboard/update`,
            { classData, scoreType, score, comment },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error updating class score:", error);
        throw error;
    }
};

export const getWaitlist = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/classes/waitlist`, {
            params: { classId },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching waitlist:", error);
    }
};

// Uuenda oma classesApi.js failis:

// UPDATED: createWaitlist with family member support
export const createWaitlist = async (classId, userPlanId, isFamilyMember, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes/waitlist`,
            {
                classId,
                userPlanId,
                isFamilyMember,
                familyMemberId
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error creating waitlist:", error);
        throw error;
    }
};

// UPDATED: deleteWaitlist with family member support
export const deleteWaitlist = async (classId, isFamilyMember, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/classes/waitlist/remove`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            data: {
                classId,
                isFamilyMember,
                familyMemberId
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error deleting waitlist:", error);
        throw error;
    }
};

// Get classes for a specific day
export const getClassesForDay = async (affiliateId, date) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/trainer/day/${affiliateId}/${date}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error getting classes for day:", error);
        throw error;
    }
};

// Assign trainer to multiple classes
export const assignTrainerToClasses = async (classIds, trainerName) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/trainer/assign-trainer`,
            {
                classIds,
                trainerName
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error assigning trainer to classes:", error);
        throw error;
    }
};

export const registerMemberForClass = async (classId, planId, affiliateId, memberInfo) => {
    try {
        const token = localStorage.getItem("token");

        // Determine if we're registering a user or a family member
        const payload = {
            classId,
            planId,
            affiliateId
        };

        if (memberInfo.type === 'familyMember') {
            payload.memberType = 'familyMember';
            payload.memberId = memberInfo.id;
        } else {
            payload.userId = memberInfo.id;
            payload.memberType = 'user';
        }

        const response = await axios.post(`${API_URL}/trainer/register-member`,
            payload,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error registering for class:", error);
        throw error;
    }
};

// Search users by name
export const searchUsersByName = async (query) => {
    const token = localStorage.getItem("token");
    try {
        const response = await axios.get(`${API_URL}/trainer/search-users`, {
            params: { q: query },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error searching users:", error);
        return [];
    }
};

// Get family members for a user
export const getFamilyMembers = async (userId) => {
    const token = localStorage.getItem("token");
    try {
        const response = await axios.get(`${API_URL}/trainer/family-members`, {
            params: { userId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching family members:", error);
        return [];
    }
};

export const addClassToMyTrainings = async (classId, addCompetition, selectedTrack = 'rx') => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/classes/add-training`,
            { classId, addCompetition, selectedTrack },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error adding class to my trainings:", error);
    }
};

export const promoteFromWaitlist = async (waitlistId) => {
    const response = await fetch(`${API_URL}/classes/promote-from-waitlist`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ waitlistId })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to promote from waitlist');
    }

    return response.json();
};

// Guest registration for free classes (no authentication required)
export const registerGuestForClass = async (classId, firstName, lastName, email, affiliateId, additionalInfo) => {
    try {
        const response = await axios.post(`${API_URL}/classes/guest-register`, {
            classId,
            firstName,
            lastName,
            email,
            affiliateId,
            additionalInfo
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error in guest registration:", error);
        throw error;
    }
};

// Get guest registrations for a class (requires authentication)
export const getGuestRegistrations = async (classId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/classes/guest-registrations`, {
            params: { classId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching guest registrations:", error);
        throw error;
    }
};

// Delete guest registration (requires authentication)
export const deleteGuestRegistration = async (guestId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/classes/guest-registrations/${guestId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error deleting guest registration:", error);
        throw error;
    }
};